// PRIMERO: fija el runtime (prod/dev) antes de que ningún módulo lea `window.__env`.
import './app/core/config/runtime-bootstrap';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Aquí vivían dos parches globales, retirados en la revisión de octubre de 2026:
//  - un filtro de `console.log` que comparaba cada traza con 49 textos (41 ya no
//    existían); las tres trazas que tapaba se borraron en origen (24-10-2026);
//  - un `localStorage.getItem` que devolvía null para claves con «auth_token». Solo
//    bloqueaba las lecturas de una vía paralela de caducidad de sesión por localStorage
//    que, precisamente por el parche, nunca llegó a usarse; la vía y el parche se fueron
//    juntos (25-10-2026) y la caducidad se lee siempre del JWT.
bootstrapApplication(App, appConfig);

